import { render, staticRenderFns } from "./textPlanView.vue?vue&type=template&id=66c70483&scoped=true"
import script from "./textPlanView.vue?vue&type=script&lang=js"
export * from "./textPlanView.vue?vue&type=script&lang=js"
import style0 from "./textPlanView.vue?vue&type=style&index=0&id=66c70483&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c70483",
  null
  
)

export default component.exports